import jsPDF from 'jspdf';
import 'jspdf-autotable';
import HTTPRequest from '../../../controllers/httpRequest';
import secureStorage from '../../../controllers/secureStorage.js';
import moment from 'moment';

var printPcv = {
    methods: {
        async printPCV() {
            this.spinning = true;

            let tabulatorInstance = this.$refs.tabulator.getInstance();
            let tableData = tabulatorInstance.getData();
            let documentDetails = this.documentDetails;
            const childDocs = await this.fetchChildDocuments(documentDetails.id);
            documentDetails.child_doc = childDocs;

            // console.log("====CHECKPOINT START====")
            // console.log("childDocs", childDocs);
            // console.log("tableData", tableData);
            // console.log("documentDetails", documentDetails);
            // console.log("====CHECKPOINT END====")

            const doc = new jsPDF('l', 'pt', 'a4');
            const pageWidth = doc.internal.pageSize.getWidth();
            const pageHeight = doc.internal.pageSize.getHeight();
            const userName = secureStorage.getItem("userName");
            let xLeftKey = 40;

            function formatNumber(val) {
                if (!val) return '0.00';
                return new Intl.NumberFormat('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                }).format(val);
            }

            function formatDate(date, labelIfMissing = '') {
                if (!date) {
                    return labelIfMissing;
                }
                return moment(date).isValid() ? moment(date).format('MM/DD/YYYY') : labelIfMissing;
            }

            function formatDateTime(date, labelIfMissing = '') {
                if (!date) {
                    return labelIfMissing;
                }
                return moment(date).isValid() ? moment(date).format('MM/DD/YYYY HH:mm:ss') : labelIfMissing;
            }

            // header
            doc.setFontSize(14);
            doc.setFontStyle("bold");
            doc.text('PHYSICAL COUNT VERIFICATION', xLeftKey, 30);

            doc.setFontSize(10);
            doc.setFontStyle("normal");
            doc.text(`Company: ${documentDetails.company_name || ''}`, xLeftKey, 55);
            doc.text(`Supplying Branch: ${documentDetails.target_site_name || ''}`, xLeftKey, 70);
            doc.text(`Resolution: ${documentDetails.resolution || ''}`, xLeftKey, 85);
            
            const remarksText = `Remarks: ${documentDetails.remark || ''}`;
            const maxRemarksWidth = pageWidth - 250 - xLeftKey - 20;
            const wrappedRemarksText = doc.splitTextToSize(remarksText, maxRemarksWidth);
            doc.text(wrappedRemarksText, xLeftKey, 100);

            doc.setFontStyle("bold");
            doc.text("PCV REF #:", pageWidth - 250, 55);

            doc.setFontStyle("normal");
            doc.text(`${documentDetails.code_and_document_no || ''}`, pageWidth - 192, 55);

            doc.setFontStyle("normal");
            doc.text(`Posting Date: ${formatDate(documentDetails.posted_at, 'Not posted')}`, pageWidth - 250, 70);
            doc.text(`Purpose: ${documentDetails.purpose_id.label || ''}`, pageWidth - 250, 85);
            doc.text(`Status: ${documentDetails.status || ''}`, pageWidth - 250, 100);
            
            // wrap text if too long
            let childDocHeight = 15;
            if (childDocs) {
                const childText = `Child Document: ${childDocs}`;
                const maxWidth = 200;
                const wrappedChildText = doc.splitTextToSize(childText, maxWidth);
                doc.text(wrappedChildText, pageWidth - 250, 115);
                childDocHeight = wrappedChildText.length * 15;
            } else {
                doc.text(`Child Document: `, pageWidth - 250, 115);
            }

            const remarksHeight = wrappedRemarksText.length * 15;
            const tableStartY = Math.max(155, 100 + remarksHeight + 15, 115 + childDocHeight + 15);

            // table
            const tableColumns = [
                { header: 'LINE NO.', dataKey: 'line_no' },
                { header: 'BARCODE', dataKey: 'barcode' },
                { header: 'DESCRIPTION', dataKey: 'product_name' },
                { header: 'BRAND', dataKey: 'brand_name' },
                { header: 'COUNT QTY', dataKey: 'quantity' },
                { header: 'FREEZE QTY', dataKey: 'actual_quantity' },
                { header: 'VARIANCE', dataKey: 'variance_quantity' },
                { header: 'SUBTOTAL', dataKey: 'subtotal' },
            ];

            const tableBody = tableData.map((row, index) => ({
                line_no: index + 1,
                barcode: row.barcode,
                product_name: row.product_name,
                brand_name: row.brand_name,
                quantity: row.quantity,
                actual_quantity: row.actual_quantity,
                variance_quantity: row.variance_quantity,
                subtotal: formatNumber(row.subtotal),
            }));

            doc.autoTable({
                columns: tableColumns,
                body: tableBody,
                startY: tableStartY,
                styles: { fontSize: 9 },
                headStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], halign: 'center' },
                columnStyles: {
                line_no: { halign: 'left', cellWidth: 50 },
                barcode: { halign: 'left', cellWidth: 100 },
                description: { halign: 'center', cellWidth: 120 },
                brand: { halign: 'center', cellWidth: 100 },
                count_qty: { halign: 'left', cellWidth: 60 },
                freeze_qty: { halign: 'left', cellWidth: 60 },
                variance: { halign: 'left', cellWidth: 60 },
                subtotal: { halign: 'right', cellWidth: 80 },
                },
                margin: { left: 40, right: 40 },
                tableLineWidth: 0.5,

                // footer
                didDrawPage: (data) => {
                    const pageHeight = doc.internal.pageSize.getHeight();
                    const pageWidth = doc.internal.pageSize.getWidth();

                    doc.setFontSize(10);
                    doc.setFontStyle("normal");
                    doc.text(`Created By: ${documentDetails.created_by || ''}`, 40, pageHeight - 40);
                    doc.text(`Creation Date: ${moment(documentDetails.created_at).format('MM/DD/YYYY HH:mm:ss')}`, 40, pageHeight - 25);
                    doc.text(`Posted By: ${documentDetails.posted_by || userName}`, pageWidth - 250, pageHeight - 40);
                    doc.text(`Posting Date: ${formatDateTime(documentDetails.posted_at, 'Not posted')}`, pageWidth - 250, pageHeight - 25);              

                    // const pageCount = doc.internal.getNumberOfPages();
                    // doc.text(`Page ${data.pageNumber} of ${pageCount}`, pageWidth - 40, pageHeight - 10, { align: 'right' });
                }
            });

            let pdfWindow = window.open(doc.output('bloburl'), '_blank');

            this.spinning = false;
        },
        async fetchChildDocuments(documentId) {
            try {
                const response = await HTTPRequest.getRequest(this.endPoint + '/documents/get_related_document?document_id=' + documentId, null, null);

                console.log("response", response);

                if (response && response.grand_children) {
                    console.log("response.grand_children", response.grand_children);
                    return response.grand_children.map(child => child.cas_no).join(', ');
                }
                return '';
            } catch (error) {
                console.error("Failed to fetch child documents", error);
                return '';
            }
        },
    }  
};

export default printPcv;
